// extracted by mini-css-extract-plugin
export default {"expense":"ExpenseForm_expense__B3aR1"};